<template>
  <!-- Main Content -->
  <ViewWrapper id="profile" :title="t('profile.pageTitle')" class="w-100">
    <div class="mt-4">
      <!-- Loading State -->
      <template v-if="isLoading"> </template>
      <template v-else>
        <!-- Error State -->
        <!-- <p v-if="error" class="error">{{ error }}</p> -->

        <SettingsSection />
        <InfoSection />
      </template>
    </div>
  </ViewWrapper>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import { useStore } from '@/store'

  // VUE Components
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import SettingsSection from '@/components/Profile/SettingsSection.vue'
  import InfoSection from '@/components/Profile/InfoSection.vue'

  // Composables

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Store Setup
  const store = useStore()

  // Computed properties for state
  const isLoading = computed(() => {
    // Profile page should only wait for auth-related loading that requires hiding the entire page
    // Exclude updateUserInfo since EditInfoForm has its own loading indicator
    const authLoadingStates = store.state.auth?.loading || {}
    const relevantLoadingActions = ['login', 'refresh', 'register', 'logout']
    
    return relevantLoadingActions.some(action => authLoadingStates[action]) || false
  })

  // onMounted(async () => {})
</script>

<style scoped></style>
